__turbopack_context__.v({
  "breadcrumbs": "Breadcrumbs-module__TRGCrG__breadcrumbs",
  "current": "Breadcrumbs-module__TRGCrG__current",
  "ellipsis": "Breadcrumbs-module__TRGCrG__ellipsis",
  "icon": "Breadcrumbs-module__TRGCrG__icon",
  "item": "Breadcrumbs-module__TRGCrG__item",
  "link": "Breadcrumbs-module__TRGCrG__link",
  "list": "Breadcrumbs-module__TRGCrG__list",
  "separator": "Breadcrumbs-module__TRGCrG__separator",
  "separatorIcon": "Breadcrumbs-module__TRGCrG__separatorIcon",
  "text": "Breadcrumbs-module__TRGCrG__text",
});
